<router-outlet></router-outlet>

<app-confirm-dialog />

<app-loading-gk></app-loading-gk>

<app-toast type="2"></app-toast>
